<!--
    功能：获取教学平台初始化信息
-->
<template>
  <div id="app">
    <router-view v-if="isRouterAlive && show"/>
    <el-dialog
      :visible.sync="dialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="提示"
      width="600px">
      <span style="color: red;">当前校区已被禁用，请重新选择校区！</span>
      <el-select
        v-model="value"
        size="mini"
        placeholder="切换校区"
        @change="changeDepartment">
        <el-option
          v-for="(item, index) in options"
          :key="index"
          :label="item.name"
          :value="item.id"/>
      </el-select>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          type="primary"
          @click="logout">退出登录</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>

/* eslint-disable no-unused-expressions */
/* eslint-disable default-case */
import { token } from '@/utils';
import baseUrl from './utils/api';
import VueCookie from 'vue-cookie';
import fackClickOutSide from '@/mixins/fackClickOutSide.js'; // DSY:干预 el插件的el-popper的样式


export default {
  name: 'App',
  mixins: [fackClickOutSide],
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      show: false,
      state: '',
      dialogVisible: false,
      options: [],
      value: '',
      school: [], // 校区列表
      schoolCenter: this.$route.query.from === 'schoolCenter',
    };
  },
  created() {
    if (this.schoolCenter) {
      this.$store.state.schoolCenter = true;

      window.top.postMessage({
        type: 'itGetIntConfig',
      }, '*');

      window.onmessage = (event) => {
        const type = event.data.type;
        const val = event.data.value;
        console.log('数据来源window.onmessage ', event.data.type, event.data.value);

        if (type) {
          this.$store.state.iframeFn && this.$store.state.iframeFn(type, event.data);

          switch (type) {
            // 教学平台 - 获取token等信息
            case 'centerGetIntConfig':
              token.set(val.token);
              this.$store.state.from = this.$route.query.from;
              this.$store.state.showFull = this.$route.query.showFull;

              val.school.map((item) => {
                if (item.id === Number(val.school_id)) {
                  this.$store.state.appId = val.client_id;
                  this.$store.commit('initSchoolList', val);

                  this.$store.commit('setApiUrl', `${this.$checkHttp()}${item.domain}`);
                  this.$store.commit('setChoicesSchool', item);
                  this.$store.commit('initUser', val.user);
                  this.$store.commit('initMainUser', val.users);

                  this.getCategory();

                  if (this.$store.state.user.id) {
                    this.show = true;
                  }
                  VueCookie.set('im-client-id', this.$store.state.appId, { expires: 30, domain: this.$domain.domain });
                }
              });
              break;
            case 'centerchangeSelectSchoolId':
              // 教学平台 - 校区切换
              this.$store.state.school.map((item) => {
                if (item.id === Number(val.school_id)) {
                  this.$store.commit('setApiUrl', `${this.$checkHttp()}${item.domain}`);
                  localStorage.setItem('choicesSchool', JSON.stringify(item));
                  this.$store.commit('setChoicesSchool', item);
                  this.$store.commit('initUser', val.user);
                  this.$store.commit('initMainUser', val.users);
                  this.init(val);
                  this.reload();
                }
              });
              break;
            case 'centerGetFullpath':
              // 教学平台 - 面包屑
              console.log(val, 'centerGetFullpath');
              (val === this.$route.fullPath || val === this.$route.path || val === this.$route.redirectedFrom) ? this.reload() : this.$router.push(val);
              break;
          }
        }
      };
    } else if (this.$route.path !== '/cloud') {
      window.onmessage = (event) => {
        const type = event.data.type;

        type && this.$store.state.iframeFn && this.$store.state.iframeFn(type, event.data);
      };

      const reg = name => new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
      const state = window.location.hash.substr(1).match(reg('state'));
      const stateType = state ? decodeURIComponent(state[2]) : 4;
      const result = window.location.hash.substr(1).match(reg('access_token'));
      const access_token = result ? decodeURIComponent(result[2]) : null;

      const access_tokens = this.getQueryVariable('access_token');
      const _isLive = this.getQueryVariable('isLive');
      const _school_id = this.getQueryVariable('school_id');
      const access_client_id = this.getQueryVariable('access_client');
      const _client = this.getQueryVariable('client');

      if (stateType === 'authpage' || stateType === 'authpageh5') {
        this.state = 4;
        this.$store.state.appId = 4;
        this.$router.push('/auth');
      }

      _isLive && localStorage.setItem('isLive', _isLive);

      _school_id && localStorage.setItem('school_id', _school_id);

      if (access_client_id) {
        this.$store.state.appId = access_client_id;
        localStorage.setItem('access_client_id', access_client_id);
      } else if (localStorage.getItem('access_client_id')) {
        this.$store.state.appId = localStorage.getItem('access_client_id');
      }

      if (_client) {
        this.$store.state.appId = _client;
        localStorage.setItem('client_id', _client);
      } else if (localStorage.getItem('client_id')) {
        this.$store.state.appId = localStorage.getItem('client_id');
      }

      if (localStorage.getItem('access_client_id')) {
        this.$store.state.from = 'client';
      }

      const _tokens = access_token || access_tokens;

      if (_tokens) {
        token.set(_tokens);
        this.load();
      } else if (!token.get()) {
        window.location.href = `${baseUrl}/oauth/authorize?client_id=4&redirect_uri=${window.location.origin}&response_type=token&scope=&state=${stateType}`;
      } else {
        token.set(token.get());
        this.load();
      }

      VueCookie.set('im-client-id', this.$store.state.appId, { expires: 30, domain: this.$domain.domain });
    } else {
      this.show = true;
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.top.postMessage({
        type: 'itGetCompleted',
      }, '*');
    });
  },
  methods: {
    getQueryVariable(variable) {
      const vars = window.location.search.substring(1).split('&');

      for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return (false);
    },
    load() {
      if (this.$route.path === '/auth') {
        this.show = true;
      } else {
        this.$http.get('/api/school')
          .then((res) => {
            if (res.school.length > 0) {
              this.$store.commit('initSchoolList', res); // 初始化校区列表
              this.$store.dispatch('initMainUser'); // 初始化主体用户信息
              // this.$store.dispatch('initSchoolCategory'); // 初始化校区类目
              this.init(res);
            } else {
              // this.$confirm('当前账号没有主体认证，请先认证审核！', '提示', {
              //   distinguishCancelAndClose: true,
              //   customClass: "auth_dialog_box",
              //   confirmButtonText: '去认证',
              //   cancelButtonText: '切换账号',
              //   showClose: false,
              //   closeOnPressEscape: false,
              //   closeOnClickModal: false
              // })
              //   .then(() => {
              //     this.$router.push({
              //       path: '/auth',
              //       query: {
              //         source: 'school'
              //       }
              //     });
              //     this.show = true;
              //   })
              //   .catch(() => {
              //     window.location.href = `${baseUrl}/sso/logout?client_id=4&redirect_uri=${this.$domain.schoolManagement}&response_type=token&scope=&state=4`
              //   });
              window.location.href = `${baseUrl}/sso/logout?client_id=4&redirect_uri=${this.$domain.schoolManagement}&response_type=token&scope=&state=4`;
            }
          })
          .catch((err) => {
            if (err.status_code === 403) {
              if (token.get()) {
                token.remove();
                window.location.reload();
              }
            } else {
              this.$message.error(err.message);
            }
          });

        this.getCategory();
      }
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    getCategory() {
      this.$http.get(`${baseUrl}/api/category-school`).then((res) => {
        this.$store.state.schoolCategory = res;
      });
    },
    init(res) {
      this.options = res.school;
      const choicesSChool = localStorage.getItem('choicesSchool') || null;
      if (choicesSChool) {
        this.$store.commit('setChoicesSchool', JSON.parse(choicesSChool)); // 设置校区为选中状态
        this.$store.commit('setApiUrl', `${this.$checkHttp()}${JSON.parse(choicesSChool).domain}`); // 设置校区的api地址
        this.initUser(JSON.parse(choicesSChool));
      } else {
        localStorage.setItem('choicesSchool', JSON.stringify(res.school[0]));
        this.$store.commit('setChoicesSchool', res.school[0]); // 设置第一个校区为选中状态
        this.$store.commit('setApiUrl', `${this.$checkHttp()}${res.school[0].domain}`); // 设置第一个校区的api地址
        this.initUser(res.school[0]);
      }
    },
    initUser(item) {
      this.$http.get(`${this.$checkHttp()}${item.domain}/api/user`)
        .then((res) => {
          this.$store.state.uuid = res.uuid;

          if (res.status === 2) {
            if (this.schoolCenter) {
              window.top.postMessage({
                type: 'itCloseUser',
              }, '*');
            } else {
              this.dialogVisible = true;
            }
          } else if (res.role_text.length <= 0) {
            // this.$confirm('当前账号没有主体认证，请先认证审核！', '提示', {
            //   distinguishCancelAndClose: true,
            //   customClass: "auth_dialog_box",
            //   confirmButtonText: '去认证',
            //   cancelButtonText: '切换账号'
            // })
            //   .then(() => {
            //     this.$router.push('/auth');
            //     this.show = true;
            //   })
            //   .catch(() => {
            //     window.location.href = `${baseUrl}/sso/logout?client_id=4&redirect_uri=${this.$domain.schoolManagement}&response_type=token&scope=&state=4`
            //   });

            if (this.schoolCenter) {
              window.top.postMessage({
                type: 'itCloseUser',
              }, '*');
            } else {
              window.location.href = `${baseUrl}/sso/logout?client_id=4&redirect_uri=${this.$domain.schoolManagement}&response_type=token&scope=&state=4`;
            }
          } else {
            localStorage.setItem('choicesSchool', JSON.stringify(item));
            this.$store.commit('setApiUrl', `${this.$checkHttp()}${item.domain}`); // 设置切换校区api地址
            this.$store.commit('setChoicesSchool', item); // 设置选择的校区
            this.$store.commit('initUser', res); // 初始化用户信息
            // this.$store.dispatch('initUserRole'); // 初始化角色列表
            // this.$store.dispatch('initGrade'); // 初始化年级列表
            this.show = true;
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    changeDepartment(val) {
      this.options.forEach((item) => {
        if (item.id === val) {
          this.dialogVisible = false;
          this.initUser(item);
        }
      });
    },
    logout() {
      this.$token.remove();
      window.location.href = `${baseUrl}/sso/logout?client_id=4&redirect_uri=${window.location.origin}&response_type=token&scope=&state=4`;
    },
  },
};
</script>
<style lang="scss">
  .el-table td, .el-table th {
    padding: 13px 0;
  }
  .app-webview-bread {
    display: none;
    height: 68px;
    padding: 0 20px;
	  align-items: center;

    a {
      float: left;
      margin-right: 17px;
      color: #FFC433 !important;
    }
    /deep/ .el-breadcrumb__separator {
      margin: 0 4px;
      font-weight: normal;
    }
  }
  .app-webview-back {
    display: none;
    color: #FFC433 !important;
    margin: -10px 0 10px -20px;
  }
  .app-webview {
    .main-content {
      padding-bottom: 0 !important;
    }
    .el-aside,
    .main-header,
    .page_header {
      display: none !important;
    }
  }
  .school-center-theme {
    background: none !important;

    .main-body {
      flex: 1;
      margin: 0 !important;
      padding: 20px 34px !important;
    }
    .school-center-padding {
      padding-top: 0 !important;
    }
    &.show-full {
      .main-body {
        margin: 0 0 0 20px !important;
        padding: 20px 34px !important;
        border-radius: 20px;
      }
      .el-aside {
        overflow: hidden;
        display: block !important;
        width: 164px !important;
        border-radius: 20px;
        font-weight: 500;
      }

      .main-menu__title,
      .main-menu [class^=el-icon-] {
        display: none;
      }
      .main-menu {
        width: 164px;
      }
      .el-menu {
        padding: 20px 16px;
        background: #fff;

        > .el-submenu,
        > .no_children {
          margin-top: 10px !important;

          &:first-child {
            margin-top: 0 !important;
          }
        }
      }
      .el-menu-item, .el-submenu__title {
        height: 40px;
        line-height: 40px;
      }
      .no_children {
        color: #303133 !important;
        padding: 0 0 0 18px;
        border-radius: 22px;

        &.is-active {
          background: #F5F7FB !important;
          color: #EFB600 !important;
        }
      }
      .el-submenu__title {
        color: #303133;
      }
      .el-submenu:hover .el-submenu__title {
        color: #EFB600;
      }
      .el-submenu__title:after {
        display: inline-flex;
        vertical-align: middle;
        content: '';
        width: 0;
        margin-left: 30px;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 5px solid #1A1C2B;
      }
      .is-opened {
        .el-submenu__title:after {
          transform: rotate(180deg);
        }
      }
      .el-menu--inline {
        padding: 0;

        .el-menu-item {
          padding-left: 28px !important;
          margin-top: 10px !important;
          background: none;
          color: #303133;
          min-width: auto;
          border-radius: 22px;

          &:first-child {
            margin-top: 0 !important;
          }
          &.is-active {
            background: #F5F7FB !important;
            color: #EFB600 !important;
          }
          &:hover {
            background: none;
            color: #EFB600 !important;
          }
        }
      }
    }
  }
  .client-theme {
    .main-body {
      margin: 18px 16px !important;
    }
    .app-webview-back {
      display: block;
    }
  }

  .school-center-theme {
    .el-button {
      background: #fff;
      border-color: rgba(211, 216, 226, 1);
      color: #909399;
      font-size: 14px;
      transition: background .2s ease-out;

      &:focus, &:hover {
        background: rgba(239, 182, 0, .1);
        border-color: rgba(211, 216, 226, .6);
        color: #909399;
      }
      &.btn-gray {
        min-width: 95px;
        color: #262523;
        background: #F0F2F5;
        border-radius: 4px;
        border: 1px solid #D3D8E2;
      }
    }
    .el-button--primary {
      min-width: 95px;
      background: rgba(239, 182, 0, 1);
      border-color: #EFB600;
      color: #fff;

      &:focus, &:hover {
        background: rgba(239, 182, 0, .6);
        border-color: rgba(239, 182, 0, .6);
        color: #fff;
      }
    }

    .el-input.is-active .el-input__inner,
    .el-input__inner:focus {
      border-color: #EFB600;
    }

    .el-table th {
      height: 55px;
      padding: 4px 0;
      color: #000;
      background: #F5F7FA;
    }
    .el-link.el-link--default {
      color: #EFB600;
    }
  }

  .icon-splite {
    font-style: normal;
    margin: 0 5px;
    color: rgba(0, 0, 0, 0.09);
  }
  .el-dialog, .el-message-box{
    display: flex;
    flex-direction: column;
    margin:0 !important;
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
    max-height:calc(100% - 30px);
    max-width:calc(100% - 30px);
  }

  .el-dialog .el-dialog__body{
    flex:1;
    overflow: auto;
  }
   .el-table{
   //滚动条的宽度
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #f0f0f0;
  border-radius: 6px;
}
//滚动条的滑块
::-webkit-scrollbar-thumb {
  background-color: rgba(144,147,153,.2);
  border-radius: 6px;
}
   }
</style>



// WEBPACK FOOTER //
// src/App.vue